// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/habitaciones/list',
    name: 'habitaciones-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/Habitaciones.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_habitacion_hotels',
    },
  },
]

export default formTable
